import React from 'react'
import PropTypes from 'prop-types'
import { UserItem } from 'shared/UI/UserItem'
import { ARTICLE_HEADER_POSITIONS } from 'App/modules/articles/articles'
import get from 'lodash/get'
import find from 'lodash/find'

import './style.css.scss'

const HeaderInfo = (props) => {
  const publishedAt = get(props.article, 'published_at', {})
  const author = get(props.article, 'author', {})
  const readTime = get(props.article, 'read_time', {})
  const currentAuthor = find(props.authors, { id: author.value })
  const isHeaderEmpty = !find([publishedAt, author, readTime], 'should_display')
  const readOnlyClass = props.readOnly ? 'read-only' : ''
  const emptyHeaderClass = isHeaderEmpty ? 'empty' : ''
  const articleHeaderPosition = get(props.article, 'header_settings.position', ARTICLE_HEADER_POSITIONS.top)
  const articleHeaderBottomPositionClass = articleHeaderPosition === ARTICLE_HEADER_POSITIONS.bottom ? 'article-header-bottom' : ''
  
  return (
    <div className={`article-header-info ${readOnlyClass} ${emptyHeaderClass} ${articleHeaderBottomPositionClass}`}>
      { author.should_display &&
        <UserItem user={currentAuthor} onClick={props.onClick} />
      }
      <aside>
        { publishedAt.should_display &&
          <span className='published-at' onClick={props.onClick}>
            {publishedAt.value}
          </span>
        }
        { readTime.should_display &&
          <span className='read-time' onClick={props.onClick}>
            {`${readTime.value} min read`}
          </span>
        }
      </aside>
    </div>
  )
}

HeaderInfo.propType = {
  article: PropTypes.object,
  authors: PropTypes.array,
  readOnly: PropTypes.bool,
  onClick: PropTypes.func
}

export default HeaderInfo